import { useQuery } from '@apollo/client';
import { faCloudDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ApolloProviderV4 } from '~/apollo/client-v4';
import { graphql } from '~/apollo/generated/v4';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { Button } from '~/components/ui/button';
import { saveAs } from '~/utils/export';
import { createKmlDocument, createKmlFolder } from '~/utils/kml-v4';

const EXPORT_VOM_GEOREFERENCES = graphql(`
  query ExportVomGeoreferences {
    virtualOutcropModelList {
      results {
        id
        name
        georeferences {
          ...georeferenceParts
        }
      }
    }
  }
`);

export default function ExportGeoreferencesAllVomsPage() {
  return (
    <ApolloProviderV4>
      <ExportGeoreferencesAllVomsPageInner />
    </ApolloProviderV4>
  );
}

function ExportGeoreferencesAllVomsPageInner() {
  const { data, loading, error } = useQuery(EXPORT_VOM_GEOREFERENCES);

  const vomList = data?.virtualOutcropModelList?.results ?? [];

  async function handleClick() {
    const vomFolders = vomList
      .map(vom => {
        if (!vom.georeferences.length) return null;
        return createKmlFolder(
          vom.name,
          `${vom.name} Georeferences`,
          vom.georeferences,
        );
      })
      .filter(folder => !!folder);

    const document = await createKmlDocument(vomFolders);
    saveAs(
      document,
      'SafariDB Virtual Outcrop Models.kml',
      'application/vnd;charset=utf-8',
    );
  }

  if (error) {
    return (
      <p>An error occurred while loading the VOM list. Please try again.</p>
    );
  }

  if (loading) {
    return (
      <SpinnerPlaceholder>
        Loading data for all VOMs, this may take a long time...
      </SpinnerPlaceholder>
    );
  }

  return (
    <div className="text-center">
      {data && (
        <Button
          type="button"
          color="primary"
          className="gap-1"
          onClick={handleClick}
        >
          <FontAwesomeIcon icon={faCloudDownload} /> Save KML
        </Button>
      )}
    </div>
  );
}
